// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"1a8958ce","36":"c526c2b4","73":"e6b80bd4","251":"b1b0bc89","302":"78aa42d0","379":"6e04d7f8","387":"fdbe04eb","460":"01b4e180","488":"9e6ea7b4","490":"6bd1688b","684":"20e69ea9","747":"9c570b60","860":"7bd41dc0","896":"274b5cd2","970":"f0381bad"}[chunkId] + ".chunk.js";
};